import type { ReactNode } from 'react';
import { ModuleSectionLayout } from './ModuleSectionLayout';
import { useActiveModule } from '@/hooks/useActiveModule';
import { getModuleEntryByErpModule } from '@/config/moduleEntries';
import { moduleAdminPath } from '@/config/moduleDefaults';

interface AdministrationLayoutProps {
  title: string;
  description?: string;
  children: ReactNode;
}

export function AdministrationLayout({ title, description = '', children }: AdministrationLayoutProps) {
  const activeModule = useActiveModule();
  const entry = activeModule ? getModuleEntryByErpModule(activeModule) : undefined;
  const moduleLabel = entry?.label ?? 'Workspace';
  const homePath = entry?.homePath ?? '/org';

  return (
    <ModuleSectionLayout
      section="Administration"
      title={title}
      description={description}
      moduleLabel={moduleLabel}
      breadcrumbs={[
        { label: moduleLabel, to: homePath },
        {
          label: 'Administration',
          to: activeModule ? moduleAdminPath(activeModule, 'administration') : undefined,
        },
      ]}
    >
      {children}
    </ModuleSectionLayout>
  );
}
